import { OverlayPanel } from "primereact/overlaypanel";
import CheckMenu from "../pengecekan-form/CheckMenu";

const EditorPopover = ({
  overlayRef,
  popoverPengecekanData,
  handleOnClickFoto,
  pengecekanBerangkatDetilData,
  pengecekanKembaliDetilData,
  isBerangkat,
  handleOnClickReload,
  handleOnClickEditNote
}) => {
  return (
    <OverlayPanel
      className=""
      ref={overlayRef}
      pt={{ content: { className: "col-start-center py-1 px-0" } }}
    >
      <CheckMenu
        row={popoverPengecekanData}
        onClickFoto={handleOnClickFoto}
        pengecekanBerangkatDetilData={pengecekanBerangkatDetilData}
        pengecekanKembaliDetilData={pengecekanKembaliDetilData}
        isBerangkat={isBerangkat}
        onClickReload={handleOnClickReload}
        onClickEditNote={handleOnClickEditNote}
        // onClickDeskripsi={onClickDeskripsi}
      />
    </OverlayPanel>
  );
};

export default EditorPopover;
